import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="w-full bg-[#1a2332] py-8 px-4" data-id="element-69" data-mp="32onll67cnuaj">
        <div className="max-w-6xl mx-auto text-center" data-id="element-70" data-mp="32m1c310wf4po">
          <div className="text-xl font-bold text-[#fbbf24] mb-2" data-id="element-71" data-mp="36q953aee36tp">
            Solo-Survival.com
          </div>
          <p className="text-gray-400 text-sm mb-4" data-id="element-72" data-mp="3ufjyu7xbo0yc">
            © 2026 Solo-Survival. Todos los derechos reservados.
          </p>
          <div className="flex items-center justify-center gap-4 text-sm" data-id="element-73" data-mp="3lecaoioisghz">
            <button onClick={() => setActiveModal('privacy')} className="text-gray-400 hover:text-[#fbbf24] transition-colors underline underline-offset-2" data-id="element-74" data-mp="3le2fmgombj5f">
              Política de Privacidad
            </button>
            <span className="text-gray-600" data-id="element-75" data-mp="2eyjqjn8892v5">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-gray-400 hover:text-[#fbbf24] transition-colors underline underline-offset-2" data-id="element-76" data-mp="2ew734ujpa0ap">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4" onClick={() => setActiveModal(null)} data-id="element-77" data-mp="3q8wrtvcwqqet">
          <div className="bg-white rounded-lg shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-78" data-mp="817cu4ckvmt0">
            <div className="sticky top-0 bg-white border-b border-gray-200 flex items-center justify-between p-6 rounded-t-lg" data-id="element-79" data-mp="hrigdpscntzd">
              <h2 className="text-2xl font-bold text-[#1a2332]" data-id="element-80" data-mp="cvto87intfd3">
                {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h2>
              <button onClick={() => setActiveModal(null)} className="p-2 rounded-full hover:bg-gray-100 transition-colors" aria-label="Cerrar" data-id="element-81" data-mp="tv4mo01f303y">
                <XIcon className="w-5 h-5 text-gray-600" data-id="element-82" data-mp="13tkey6c6kff1" />
              </button>
            </div>

            <div className="p-6 text-gray-700 leading-relaxed space-y-4" data-id="element-83" data-mp="18jr0fxbebjt2">
              {activeModal === 'privacy' ? <>
                  <p className="text-sm text-gray-500" data-id="element-84" data-mp="1ckt20kssc7y7">
                    Última actualización: Enero 2024
                  </p>

                  <h3 className="text-lg font-semibold text-[#1a2332]" data-id="element-85" data-mp="1hms2nmx54qrg">
                    1. Información que recopilamos
                  </h3>
                  <p data-id="element-86" data-mp="1rj4z2sk2lipw">
                    Recopilamos únicamente la información necesaria para
                    procesar tu compra: nombre, dirección de correo electrónico
                    y datos de pago. No almacenamos información de tarjetas de
                    crédito en nuestros servidores.
                  </p>

                  <h3 className="text-lg font-semibold text-[#1a2332]" data-id="element-87" data-mp="2agolrbdowefd">
                    2. Uso de la información
                  </h3>
                  <p data-id="element-88" data-mp="21mti67s7uw1u">
                    Tu información personal se utiliza exclusivamente para
                    entregar el producto digital adquirido y enviarte
                    comunicaciones relacionadas con tu compra. No compartimos,
                    vendemos ni cedemos tus datos a terceros con fines
                    comerciales.
                  </p>

                  <h3 className="text-lg font-semibold text-[#1a2332]" data-id="element-89" data-mp="2pa9z6ea174dh">
                    3. Protección de datos
                  </h3>
                  <p data-id="element-90" data-mp="2feq4twb48dqu">
                    Utilizamos cifrado SSL para proteger toda la información
                    transmitida durante el proceso de compra. Implementamos
                    medidas de seguridad estándar de la industria para
                    resguardar tus datos personales.
                  </p>

                  <h3 className="text-lg font-semibold text-[#1a2332]" data-id="element-91" data-mp="2ruoi1bhm6u1j">
                    4. Cookies
                  </h3>
                  <p data-id="element-92" data-mp="2wnr28t0i4r52">
                    Nuestro sitio puede utilizar cookies para mejorar tu
                    experiencia de navegación y analizar el tráfico del sitio.
                    Puedes configurar tu navegador para rechazar cookies si lo
                    prefieres.
                  </p>

                  <h3 className="text-lg font-semibold text-[#1a2332]" data-id="element-93" data-mp="3bki7hiwuwx2l">
                    5. Tus derechos
                  </h3>
                  <p data-id="element-94" data-mp="31lsx0b7aiewd">
                    Tienes derecho a acceder, rectificar o eliminar tus datos
                    personales en cualquier momento. Para ejercer estos
                    derechos, puedes comunicarte con nosotros a través de los
                    canales disponibles en nuestro sitio.
                  </p>
                </> : <>
                  <p className="text-sm text-gray-500" data-id="element-95" data-mp="1nlxu0ds5dyyn">
                    Última actualización: Enero 2024
                  </p>

                  <h3 className="text-lg font-semibold text-[#1a2332]" data-id="element-96" data-mp="1innyg22igwci">
                    1. Producto digital
                  </h3>
                  <p data-id="element-97" data-mp="1wm46bwc40sw8">
                    Solo-Survival: El Protocolo Despensa 1.0 es un producto
                    digital que incluye guías en formato PDF y plantillas en
                    formato Excel. Al completar tu compra, recibirás acceso
                    instantáneo a todos los materiales incluidos.
                  </p>

                  <h3 className="text-lg font-semibold text-[#1a2332]" data-id="element-98" data-mp="1dni1q7hdwjnk">
                    2. Licencia de uso
                  </h3>
                  <p data-id="element-99" data-mp="18w0boegwg3hd">
                    Al adquirir el producto, obtienes una licencia personal e
                    intransferible. Queda prohibida la reproducción,
                    distribución o reventa del material sin autorización
                    expresa.
                  </p>

                  <h3 className="text-lg font-semibold text-[#1a2332]" data-id="element-100" data-mp="2g9lwvwjvmyi0">
                    3. Política de reembolso
                  </h3>
                  <p data-id="element-101" data-mp="2l7nese5kgrrw">
                    Debido a la naturaleza digital del producto y su entrega
                    inmediata, no se aceptan devoluciones una vez realizada la
                    descarga. Si experimentas problemas técnicos con los
                    archivos, nos comprometemos a resolverlos.
                  </p>

                  <h3 className="text-lg font-semibold text-[#1a2332]" data-id="element-102" data-mp="22ambqyvkp1ql">
                    4. Resultados
                  </h3>
                  <p data-id="element-103" data-mp="278w7pbp4g6d9">
                    Los resultados de ahorro mencionados son promedios basados
                    en reportes de usuarios y pueden variar según los hábitos de
                    consumo, ubicación geográfica y nivel de implementación del
                    sistema por parte de cada usuario.
                  </p>

                  <h3 className="text-lg font-semibold text-[#1a2332]" data-id="element-104" data-mp="3msk5c50z59zi">
                    5. Modificaciones
                  </h3>
                  <p data-id="element-105" data-mp="1718wssqbit7w">
                    Nos reservamos el derecho de modificar estos términos en
                    cualquier momento. Las modificaciones entrarán en vigor
                    desde su publicación en el sitio web.
                  </p>
                </>}
            </div>

            <div className="border-t border-gray-200 p-6" data-id="element-106" data-mp="sd4n2e98ts19">
              <button onClick={() => setActiveModal(null)} className="w-full py-3 bg-[#1a2332] text-white font-semibold rounded-lg hover:bg-[#243447] transition-colors" data-id="element-107" data-mp="sai47igwjq3q">
                Cerrar
              </button>
            </div>
          </div>
        </div>}
    </>;
}